<template>

    <span class="notificationAlarm" v-if="customer">
      <div class="row">
        <div class="col-md-6">
          <b-form-checkbox
                v-if="customer.cardcode != 'ALLE'"
                :id="'checkbox-notificationAlarmGelb-' + (customer ? customer.id : '')"
                v-model="isGelbChecked"
                @change="toggleGelbChecked"
                name="isGelbChecked"
                value="true"
                unchecked-value="false">
            {{ $t('message.notificationAlarm_gelber_alarm') }}
          </b-form-checkbox>
          <div v-else>
            <b-button size="sm"
                      class="notification-btn-status mr-2"
                      :variant="isGelbChecked === true ? 'success' : (isGelbChecked === false ? 'danger' : 'primary')"
                      v-b-tooltip.hover.top
                      :title="isGelbChecked === true ? $t('message.customerNotifications_fuer_alle_desc') : (isGelbChecked === false ? $t('message.customerNotifications_fuer_alle_inaktiv_desc') : $t('message.customerNotifications_fuer_andere_desc'))">
              <span class="notification-btn-status-icon">
                <b-icon :icon="isGelbChecked === true ? 'check-circle-fill' : (isGelbChecked === false ? 'dash-circle-fill' : 'sliders')"></b-icon>
              </span>
              <span class="notification-btn-status-label">
                {{ isGelbChecked === true ? $t('message.customerNotifications_status_aktiviert') : (isGelbChecked === false ? $t('message.customerNotifications_status_deaktiviert') : $t('message.customerNotifications_status_individuell')) }}
              </span>
            </b-button>
            <b-button-group size="sm" class="notification-btn-actions" :id="'checkbox-notificationAlarmGelb-' + (customer ? customer.id : '')">
              <b-button v-if="isGelbChecked !== true"
                        variant="outline-success"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_aktivieren')"
                        @click="setIsGelbChecked(true)">
                <b-icon icon="check-circle-fill"></b-icon>
              </b-button>
              <b-button v-if="isGelbChecked !== false"
                        variant="outline-danger"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_deaktivieren')"
                        @click="setIsGelbChecked(false)">
                <b-icon icon="dash-circle-fill"></b-icon>
              </b-button>
            </b-button-group>
            &nbsp;<label :for="'checkbox-notificationAlarmGelb-' + (customer ? customer.id : '')">
              {{ $t('message.notificationAlarm_gelber_alarm') }}
            </label>
          </div>
        </div>
        <div class="col-md-6">
          <b-form-checkbox
              v-if="customer.cardcode != 'ALLE'"
              :id="'checkbox-notificationAlarmGelb-app-' + (customer ? customer.id : '')"
              v-model="isGelbCheckedApp"
              @change="toggleGelbCheckedApp"
              name="isGelbCheckedApp"
              value="true"
              unchecked-value="false">
              {{ $t('message.notificationAlarm_gelber_alarm_app') }}
          </b-form-checkbox>
          <div v-else>
            <b-button size="sm"
                      class="notification-btn-status mr-2"
                      :variant="isGelbCheckedApp === true ? 'success' : (isGelbCheckedApp === false ? 'danger' : 'primary')"
                      v-b-tooltip.hover.top
                      :title="isGelbCheckedApp === true ? $t('message.customerNotifications_fuer_alle_desc') : (isGelbCheckedApp === false ? $t('message.customerNotifications_fuer_alle_inaktiv_desc') : $t('message.customerNotifications_fuer_andere_desc'))">
              <span class="notification-btn-status-icon">
                <b-icon :icon="isGelbCheckedApp === true ? 'check-circle-fill' : (isGelbCheckedApp === false ? 'dash-circle-fill' : 'sliders')"></b-icon>
              </span>
              <span class="notification-btn-status-label">
                {{ isGelbCheckedApp === true ? $t('message.customerNotifications_status_aktiviert') : (isGelbCheckedApp === false ? $t('message.customerNotifications_status_deaktiviert') : $t('message.customerNotifications_status_individuell')) }}
              </span>
            </b-button>
            <b-button-group size="sm" class="notification-btn-actions" :id="'checkbox-notificationAlarmGelb-app-' + (customer ? customer.id : '')">
              <b-button v-if="isGelbCheckedApp !== true"
                        variant="outline-success"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_aktivieren')"
                        @click="setIsGelbCheckedApp(true)">
                <b-icon icon="check-circle-fill"></b-icon>
              </b-button>
              <b-button v-if="isGelbCheckedApp !== false"
                        variant="outline-danger"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_deaktivieren')"
                        @click="setIsGelbCheckedApp(false)">
                <b-icon icon="dash-circle-fill"></b-icon>
              </b-button>
            </b-button-group>
            &nbsp;<label :for="'checkbox-notificationAlarmGelb-app-' + (customer ? customer.id : '')">
              {{ $t('message.notificationAlarm_gelber_alarm_app') }}
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-checkbox
              v-if="customer.cardcode != 'ALLE'"
              :id="'checkbox-notificationAlarmRot-' + (customer ? customer.id : '')"
              v-model="isRotChecked"
              name="isRotChecked"
              @change="toggleRotChecked"
              value="true"
              unchecked-value="false">
              {{ $t('message.notificationAlarm_roter_alarm') }}
          </b-form-checkbox>
          <div v-else>
            <b-button size="sm"
                      class="notification-btn-status mr-2"
                      :variant="isRotChecked === true ? 'success' : (isRotChecked === false ? 'danger' : 'primary')"
                      v-b-tooltip.hover.top
                      :title="isRotChecked === true ? $t('message.customerNotifications_fuer_alle_desc') : (isRotChecked === false ? $t('message.customerNotifications_fuer_alle_inaktiv_desc') : $t('message.customerNotifications_fuer_andere_desc'))">
              <span class="notification-btn-status-icon">
                <b-icon :icon="isRotChecked === true ? 'check-circle-fill' : (isRotChecked === false ? 'dash-circle-fill' : 'sliders')"></b-icon>
              </span>
              <span class="notification-btn-status-label">
                {{ isRotChecked === true ? $t('message.customerNotifications_status_aktiviert') : (isRotChecked === false ? $t('message.customerNotifications_status_deaktiviert') : $t('message.customerNotifications_status_individuell')) }}
              </span>
            </b-button>
            <b-button-group size="sm" class="notification-btn-actions" :id="'checkbox-notificationAlarmRot-' + (customer ? customer.id : '')">
              <b-button v-if="isRotChecked !== true"
                        variant="outline-success"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_aktivieren')"
                        @click="setIsRotChecked(true)">
                <b-icon icon="check-circle-fill"></b-icon>
              </b-button>
              <b-button v-if="isRotChecked !== false"
                        variant="outline-danger"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_deaktivieren')"
                        @click="setIsRotChecked(false)">
                <b-icon icon="dash-circle-fill"></b-icon>
              </b-button>
            </b-button-group>
            &nbsp;<label :for="'checkbox-notificationAlarmRot-' + (customer ? customer.id : '')">
              {{ $t('message.notificationAlarm_roter_alarm') }}
            </label>
          </div>
        </div>
        <div class="col-md-6">
          <b-form-checkbox
              v-if="customer.cardcode != 'ALLE'"
              :id="'checkbox-notificationAlarmRot-app-' + (customer ? customer.id : '')"
              v-model="isRotCheckedApp"
              @change="toggleRotCheckedApp"
              name="isRotCheckedApp"
              value="true"
              unchecked-value="false">
              {{ $t('message.notificationAlarm_roter_alarm_app') }}
          </b-form-checkbox>
          <div v-else>
            <b-button size="sm"
                      class="notification-btn-status mr-2"
                      :variant="isRotCheckedApp === true ? 'success' : (isRotCheckedApp === false ? 'danger' : 'primary')"
                      v-b-tooltip.hover.top
                      :title="isRotCheckedApp === true ? $t('message.customerNotifications_fuer_alle_desc') : (isRotCheckedApp === false ? $t('message.customerNotifications_fuer_alle_inaktiv_desc') : $t('message.customerNotifications_fuer_andere_desc'))">
              <span class="notification-btn-status-icon">
                <b-icon :icon="isRotCheckedApp === true ? 'check-circle-fill' : (isRotCheckedApp === false ? 'dash-circle-fill' : 'sliders')"></b-icon>
              </span>
              <span class="notification-btn-status-label">
                {{ isRotCheckedApp === true ? $t('message.customerNotifications_status_aktiviert') : (isRotCheckedApp === false ? $t('message.customerNotifications_status_deaktiviert') : $t('message.customerNotifications_status_individuell')) }}
              </span>
            </b-button>
            <b-button-group size="sm" class="notification-btn-actions" :id="'checkbox-notificationAlarmRot-app-' + (customer ? customer.id : '')">
              <b-button v-if="isRotCheckedApp !== true"
                        variant="outline-success"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_aktivieren')"
                        @click="setIsRotCheckedApp(true)">
                <b-icon icon="check-circle-fill"></b-icon>
              </b-button>
              <b-button v-if="isRotCheckedApp !== false"
                        variant="outline-danger"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_deaktivieren')"
                        @click="setIsRotCheckedApp(false)">
                <b-icon icon="dash-circle-fill"></b-icon>
              </b-button>
            </b-button-group>
            &nbsp;<label :for="'checkbox-notificationAlarmRot-app-' + (customer ? customer.id : '')">
              {{ $t('message.notificationAlarm_roter_alarm_app') }}
            </label>
          </div>
        </div>
      </div>
    </span>

</template>

<script>

    import axios from 'axios'
    import bootbox from 'bootbox'
    axios.defaults.withCredentials = true

    export default {
      name: 'NotificationAlarm',
      props: [
        /** customer kann auch ein Objekt mit ID 'ALLE' sein, um für alle Standorte des Keyusers Werte zu setzen */
        'customer'
      ],
      data () {
        return {
          isGelbChecked:    null,
          isGelbCheckedApp: null,
          isRotChecked:     null,
          isRotCheckedApp:  null,
        }
      },
      watch: {

        customer: function () {
          this.init()
        },
        '$store.state.allEmailNotificationInactive': function () {
          console.log('allEmailNotificationInactive', this.$store.state.allEmailNotificationInactive)
          this.init()
        },
        '$store.state.allEmailNotificationActive': function () {
          console.log('allEmailNotificationActive', this.$store.state.allEmailNotificationActive)
          this.init()
        },
        '$store.state.allAppNotificationInactive': function () {
          console.log('allAppNotificationInactive', this.$store.state.allAppNotificationInactive)
          this.init()
        },
        '$store.state.allAppNotificationActive': function () {
          console.log('allAppNotificationActive', this.$store.state.allAppNotificationActive)
          this.init()
        }

      },
      created () {

        this.init()

      },
      methods: {

        toggleGelbCheckedApp: function () {

          console.log('isGelbCheckedApp', this.isGelbCheckedApp)
          this.changeGelb(null, this.isGelbCheckedApp)

        },
        toggleGelbChecked: function () {

          console.log('isGelbChecked', this.isGelbChecked)
          this.changeGelb(this.isGelbChecked, null)

        },
        setIsGelbChecked: function (newVal) {

          console.log('setIsGelbChecked newVal = ' + newVal + ' oldVal = ' + this.isGelbChecked)
          if (newVal == null || newVal === this.isGelbChecked) return
          this.confirmIfAlle(newVal, () => this.changeGelb(newVal, null))

        },
        setIsGelbCheckedApp: function (newVal) {

          console.log('newVal = ' + newVal + ' oldVal = ' + this.isGelbCheckedApp)
          if (newVal == null || newVal === this.isGelbCheckedApp) return
          this.confirmIfAlle(newVal, () => this.changeGelb(null, newVal))

        },
        toggleRotCheckedApp: function () {

          console.log('toggleRotCheckedApp', this.isRotCheckedApp)
          this.changeRot(null, this.isRotCheckedApp)

        },
        toggleRotChecked: function () {

          console.log('toggleRotChecked', this.isRotChecked)
          this.changeRot(this.isRotChecked, null)

        },
        setIsRotChecked: function (newVal) {

          console.log('setIsRotChecked newVal = ' + newVal + ' oldVal = ' + this.isRotChecked)
          if (newVal == null || newVal === this.isRotChecked) return
          this.confirmIfAlle(newVal, () => this.changeRot(newVal, null))

        },
        setIsRotCheckedApp: function (newVal) {

          console.log('newVal = ' + newVal + ' oldVal = ' + this.isRotCheckedApp)
          if (newVal == null || newVal === this.isRotCheckedApp) return
          this.confirmIfAlle(newVal, () => this.changeRot(null, newVal))

        },
        confirmIfAlle: function (newVal, onConfirm) {

          if (this.customer.cardcode === 'ALLE') {
            const key = newVal
                ? 'message.customerNotifications_fuer_alle_aktivieren_confirm'
                : 'message.customerNotifications_fuer_alle_deaktivieren_confirm'
            bootbox.confirm(this.$t(key), result => {
              if (result) onConfirm()
            })
          } else {
            onConfirm()
          }

        },
        changeGelb: function (newVal, newValApp) {

          this.showSpinner()
          console.log('changeGelb geändert auf ' + newVal + ' ' + newValApp)

          // Ausnahme setzen:
          const url     = process.env.VUE_APP_SERVER_URL + '/notification/save'
          let mandant = null
          if (this.customer) {
            mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
          }
          const params  = {
            cardcode:             this.customer ? this.customer.cardcode : null,
            mandant:              this.customer ? mandant : null,
            biotechUser_id:       this.$store.getters.user.id,
          }

          if (newVal != null) {
            params.gelberAlarm = this.customer.cardcode == 'ALLE' ? newVal : this.isGelbChecked
          } else if (newValApp != null) {
            params.gelberAlarmApp = this.customer.cardcode == 'ALLE' ? newValApp : this.isGelbCheckedApp
          }

          const that = this
          axios({
            method: 'GET',
            params: params,
            url: url,
          }).then(function () {

            console.log('isGelbChecked gespeichert.')
            if (that.customer.cardcode == 'ALLE') {

              let title = that.$t('message.customerNotifications_fuer_alle_aktivieren')
              let text = that.$t('message.customerNotifications_fuer_alle_aktivieren_ok')
              if (newVal === false || newValApp === false) {
                title = that.$t('message.customerNotifications_fuer_alle_deaktivieren')
                text = that.$t('message.customerNotifications_fuer_alle_deaktivieren_ok')
              }
              that.$bvToast.toast(text, {
                title: title,
                variant: 'success',
                autoHideDelay: 3000,
              })
              if (newVal != null) {
                that.isGelbChecked    = newVal
              }
              if (newValApp != null ) {
                that.isGelbCheckedApp = newValApp
              }

            }
            that.hideSpinner()

          }).catch(error => {
            console.log(error)
            that.$bvToast.toast(that.$t('message.customerNotifications_fuer_alle_deaktivieren_fail'), {
              title: 'Error',
              variant: 'success',
              autoHideDelay: 5000
            })
            that.hideSpinner()
          })

        },
        changeRot: function (newVal, newValApp) {

          this.showSpinner()
          console.log('changeRot geändert auf ' + newVal + ' ' + newValApp)

          // Ausnahme setzen:
          const url     = process.env.VUE_APP_SERVER_URL + '/notification/save'
          let mandant = null
          if (this.customer) {
            mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
          }
          const params  = {
            cardcode:             this.customer ? this.customer.cardcode : null,
            mandant:              this.customer ? mandant : null,
            biotechUser_id:       this.$store.getters.user.id,
          }

          if (newVal != null) {
            params.roterAlarm = this.customer.cardcode == 'ALLE' ? newVal : this.isRotChecked
          } else if (newValApp != null) {
            params.roterAlarmApp = this.customer.cardcode == 'ALLE' ? newValApp : this.isRotCheckedApp
          }

          const that = this
          axios({
            method: 'GET',
            params: params,
            url: url,
          }).then(function () {

            console.log('isRotChecked gespeichert.')
            if (that.customer.cardcode == 'ALLE') {

              let title = that.$t('message.customerNotifications_fuer_alle_aktivieren')
              let text = that.$t('message.customerNotifications_fuer_alle_aktivieren_ok')
              if (newVal === false || newValApp === false) {
                title = that.$t('message.customerNotifications_fuer_alle_deaktivieren')
                text = that.$t('message.customerNotifications_fuer_alle_deaktivieren_ok')
              }
              that.$bvToast.toast(text, {
                title: title,
                variant: 'success',
                autoHideDelay: 3000,
              })
              if (newVal != null) {
                that.isRotChecked    = newVal
              }
              if (newValApp != null) {
                that.isRotCheckedApp = newValApp
              }

            }
            that.hideSpinner()

          }).catch(error => {
            console.log(error)
            that.$bvToast.toast(that.$t('message.customerNotifications_fuer_alle_deaktivieren_fail'), {
              title: 'Error',
              variant: 'success',
              autoHideDelay: 5000,
            })
            that.hideSpinner()
          })

        },
        init: function () {

            const url     = process.env.VUE_APP_SERVER_URL + '/notification/show'
            let mandant = null
            if (this.customer) {
              mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
            }
            const params  = {
              cardcode:             this.customer ? this.customer.cardcode : null,
              mandant:              this.customer ? mandant : null,
              biotechUser_id:       this.$store.getters.user.id,
            }

            const that = this
            axios({
              method: 'get',
              params: params,
              url: url,
            }).then(function (response) {

                if (response.data && !response.data['not-available']) {
                  console.log('disableNeuerBesuchsbericht = ' + response.data.disableNeuerBesuchsbericht)
                  that.isRotChecked     = response.data.roterAlarm
                  that.isRotCheckedApp  = response.data.roterAlarmApp
                  that.isGelbChecked    = response.data.gelberAlarm
                  that.isGelbCheckedApp = response.data.gelberAlarmApp
                } else if (that.customer.cardcode != 'ALLE') {
                  console.log('keine Antwort, isChecked = false')
                  that.isRotChecked     = false
                  that.isRotCheckedApp  = false
                  that.isGelbChecked    = false
                  that.isGelbCheckedApp = false
                }

            }).catch(error => {
              console.log(error)
            })

          }

      }

    }

</script>
